<template>
  <form @submit.prevent="submitForm" class="needs-validation" novalidate enctype="multipart/form-data">
    <!-- тел -->
    <div class="row my-1">
      <label for="validation-phone" class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label"
        ><b class="orange">*</b> Телефон</label
      >
      <div class="col-3 col-sm-3 col-md-2 col-xxl-2 pe-0">
        <select v-model="objClient.country.phone" class="form-select">
          <option v-for="el in countries" :key="el.value" :value="el.value">
            {{ el.text }}
          </option>
        </select>
      </div>
      <div class="col-9 col-sm-5 col-md-5 col-lg-6 col-xl-5 col-xxl-4">
        <input
          type="tel"
          name="phone"
          v-maska="objClient.phone"
          :data-maska="objClient.mask.phone"
          v-model="form.phone"
          @maska="onMaskaPhone($event)"
          id="validation-phone"
          class="form-control"
          :class="{
            'is-invalid': (objClient.raw.phone.length && !objClient.phone.completed) || errors.form.phone.length,
            'is-valid': objClient.phone.completed && errors.form.phone.length == 0,
          }"
          :placeholder="objClient.mask.phone.replaceAll('#', 'x')" />
        <div class="invalid-feedback">{{ errors.form.phone }}</div>
      </div>
    </div>

    <!-- имя -->
    <div class="row my-1">
      <label for="validation-name" class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label"
        >Имя и фамилия</label
      >
      <div class="col-12 col-sm-8 col-md-7 col-lg-8 col-xl-7 offset-xl-0 col-xxl-6">
        <input type="text" name="fullname" class="form-control" id="validation-name" v-model="form.fullname" />
        <div class="invalid-feedback">{{ errors.form.fullname }}</div>
      </div>
    </div>

    <!-- почта -->
    <div class="row my-1">
      <label for="validation-email" class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label"
        >Адрес эл. почты</label
      >
      <div class="col-12 col-sm-8 col-md-7 col-lg-8 col-xl-7 offset-xl-0 col-xxl-6">
        <input
          type="email"
          name="email"
          placeholder="адрес эл. почты"
          id="validation-email"
          class="form-control"
          :class="{
            'is-invalid': form.email.length && errors.form.email.length,
            'is-valid': form.email.length && errors.form.email.length == 0,
          }"
          v-model="form.email" />
        <div class="invalid-feedback">{{ errors.form.email }}</div>
      </div>
    </div>

    <!-- дост -->
    <div class="row my-1">
      <label class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label">Доставка</label>
      <div class="col-12 col-sm-8 col-md-8 col-xl-9 pt-2">
        <div class="form-check">
          <input
            name="deliverytype"
            type="radio"
            id="nologin-deliverytype1"
            class="form-check-input"
            value="1"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="nologin-deliverytype1">Заберу самостоятельно</label>
        </div>
        <div class="form-check">
          <input
            name="deliverytype"
            type="radio"
            id="nologin-deliverytype2"
            class="form-check-input"
            value="2"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="nologin-deliverytype2"
            >Доставка по С.-Петербургу <br class="d-lg-none" />
            <small class="text-muted"><a href="/dostavka">стоимость и какие районы?</a></small></label
          >
        </div>
        <div class="form-check">
          <input
            name="deliverytype"
            type="radio"
            id="nologin-deliverytype3"
            class="form-check-input"
            value="3"
            v-model="form.deliverytype" />
          <label class="form-label form-check-label" for="nologin-deliverytype3"
            >Отправка ТК <br class="d-lg-none" />
            <small class="text-muted"><a href="/dostavka#tk">какие ТК используем?</a></small></label
          >
        </div>
      </div>
    </div>
    <!-- тк -->
    <div class="row my-1" v-if="form.deliverytype == 3">
      <label for="validation-tk" class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label"
        >Транспортная компания</label
      >
      <div class="col-12 col-sm-8 col-md-7 col-lg-8 col-xl-7 col-xxl-6">
        <select name="tk" id="validation-tk" class="form-select" v-model="form.tk">
          <option v-for="el in values.tklist" :key="el.id" :value="el.id">{{ el.name }} {{ el.comment }}</option>
        </select>
        <small class="text-muted"
          >Мы отправляем все заказы в жёсткой обрешетке, потому что это требование транспортных компаний к отправке
          автодеталей.</small
        >
      </div>
    </div>
    <!-- адрес -->
    <div class="row" v-if="form.deliverytype == 2 || form.deliverytype == 3">
      <label class="col-12 col-sm-4 col-md-3 col-lg-3 col-form-label text-sm-end form-label">Адрес доставки</label>
      <div class="col-12 col-sm-8 col-md-7 col-lg-8 col-xl-7 col-xxl-6 position-relative">
        <VueSuggestions
          :model.sync="form.address"
          :coordinates.sync="form.coordinates"
          :placeholder="'Начните вводить'"
          class="form-control"
          :options="suggestionOptions">
        </VueSuggestions>
      </div>
    </div>

    <div class="row my-1">
      <div class="col-12 col-sm-11 offset-sm-1 col-md-9 col-lg-10 col-xl-9 col-xxl-8">
        <div data-error class="alert alert-warning my-1 px-2 py-1" role="alert">{{ errors.form.common }}</div>
      </div>
    </div>

    <!-- кнопки -->
    <div class="row my-1">
      <div
        class="col-12 col-sm-8 offset-sm-4 col-md-7 offset-md-3 col-lg-8 offset-xl-2 col-xxl-6 offset-xxl-3 text-sm-end pt-2">
        <button
          class="btn btn-primary"
          type="submit"
          :disabled="!objClient.phone.completed || !form.agree || isLoading">
          Создать пользователя
        </button>
      </div>
    </div>

    <!-- подтверждение -->
    <div class="row my-1">
      <div class="col-12 col-sm-11 offset-sm-1 col-xl-9 col-xxl-9 pt-2">
        <div class="form-check">
          <input
            name="agree"
            id="checkAgree"
            class="form-check-input"
            :class="{
              'is-invalid': !form.agree,
              'is-valid': form.agree,
            }"
            type="checkbox"
            value=""
            v-model="form.agree" />
          <label class="form-check-label lh-sm" for="checkAgree">
            <small class="text-muted"
              >Ознакомлен с <a href="/privacy">Политикой обработки персональных данных</a
              ><!-- и Офертой интернет-магазина-->. Даю согласие на обработку своих персональных данных в соответствии с
              Федеральным законом от 27.07.2006 г. №152-ФЗ «О персональных данных».</small
            >
          </label>
          <div class="invalid-feedback">{{ errors.form.agree }}</div>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from 'axios';

import VueSuggestions from 'vue-suggestions';
import { vMaska } from 'maska';

import { checkEmail, checkPhone } from '@/composable/functions';

export default {
  directives: { maska: vMaska },
  data: function () {
    return {
      form: {
        _token: this.csrf,
        // основные
        phone: '',
        fullname: '',
        email: '',
        // дополнительные
        deliverytype: 1,
        tk: 'na',
        address: '',
        coordinates: {
          latitude: '',
          longitude: '',
        },
        //
        agree: true,
      },
      errors: {
        form: {
          phone: '',
          fullname: '',
          email: '',
          agree: '',
          //
          common: '',
        },
      },
      // для работы maska
      objClient: {
        phone: {
          completed: false,
          masked: '',
          unmasked: '',
        },
        raw: {
          phone: '',
        },
        country: {
          phone: '?',
        },
        mask: {
          phone: '',
        },
      },
      // справочники для maska
      countries: [
        // https://apps.timwhitlock.info/emoji/tables/iso3166
        { text: '🇷🇺', code: 'RU', value: '7', mask: '+7 (###) ###-##-##', compare: '+7 ' }, // 7 XXX XXX-XX-XX // россия (+ казахстан)
        { text: '🇧🇾', code: 'BY', value: '375', mask: '+375 ## ###-##-##', compare: '+375 ' }, // 375 XX XXX-XX-XX // белоруссия
        // { text: '🇦🇲', code: 'AM', value: '374', mask: '+374 ### ###-##', compare: '+374 ' }, // 374 XXX XXX-XX // армения
        // { text: '🇱🇻', code: 'LV', value: '371', mask: '+371 ### ## ###', compare: '+371 ' }, // 371 XXX XX XXX // латвия
        // { text: '🇱🇹', code: 'LT', value: '370', mask: '+370 ### #####', compare: '+370 ' }, // 370 XXX XXXXX // литва
        // { text: 'другой', code: '??', value: '?', mask: '', compare: '' }, // другое, что попало
      ],
      default: {
        country: '7',
        mask: '+7 (###) ###-##-##',
      },
      // datata token
      token: process.env.VUE_APP_DADATA_API_KEY,
      // dadata
      suggestionOptions: {
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454318
        token: process.env.VUE_APP_DADATA_API_KEY,
        type: 'ADDRESS',
        scrollOnFocus: false,
        triggerSelectOnBlur: false,
        triggerSelectOnEnter: false,
        addon: 'none',
        // @see https://confluence.hflabs.ru/pages/viewpage.action?pageId=207454320
        //onSelect(suggestion) { /* */ },
      },
      //
      isLoading: false,
    };
  },
  props: {
    csrf: {
      type: String,
      default: '',
    },
    position: {
      type: String,
      default: '',
    },
    links: {
      type: Object,
      default: () => {},
    },
    values: {
      type: Object,
      default() {
        return {};
      },
    },
    // тут не используется
    uid: {
      type: Number,
      default: 0,
    },
  },
  components: {
    VueSuggestions,
  },
  methods: {
    submitForm() {
      Object.keys(this.errors.form).forEach((key) => {
        this.errors.form[key] = '';
      });

      let isError = false;

      if (this.form.phone.length == 0) {
        this.$bs5utils.Snack.show(
          'warning',
          'Нужно ввести номер телефона для создания учётной записи.',
          this.$store.getters.delay.warning
        );

        this.errors.form.phone = checkPhone(this.form.phone, this.objClient.phone.completed);
        if (this.errors.form.phone.length) {
          isError = true;
        }
      }

      if (!this.objClient.phone.completed) {
        this.errors.form.phone = 'Нужно ввести номер телефона полностью.';
        isError = true;
      }

      if (this.form.email.length) {
        this.errors.form.email = checkEmail(this.form.email);
        if (this.errors.form.email.length) {
          isError = true;
        }
      }

      if (!this.form.agree) {
        this.errors.form.agree = 'Подтвердите согласие на обработку персональных данных.';
        isError = true;
      }

      if (isError) {
        return false;
      }

      this.isLoading = true;
      this.errors.form.common = 'Создание учётной записи...';

      axios
        .post(`/backend/profile/create/request`, this.form)
        .then((res) => {
          if (res.data.status === 'ok') {
            // подтверждение кодом -- пока отказались
            // this.$emit('go-step', { step: 'step2', uid: res.data.uid });
            // перегрузить страницу -- после логина ок
            location.reload();
            // ?
            // this.$bs5utils.Snack.show('success', res.data.message, this.$store.getters.delay.success);
          }

          if (res.data.status === 'error') {
            const errors = res.data.errors || {};
            const fieldErrors = errors.validation || {};
            const customErrors = errors.customErrors || {};
            const commonErrors = errors.common || [];

            Object.keys(fieldErrors).forEach((key) => {
              this.errors.form[key] = fieldErrors[key].join(' ');
            });

            Object.keys(customErrors).forEach((key) => {
              this.errors.form[key] = customErrors[key].join(' ');
            });

            this.errors.form.common = commonErrors.join(' ');
            this.errors.form.common += res.data.message;

            // ?
            // this.$bs5utils.Snack.show('warning', res.data.message, this.$store.getters.delay.warning);
          }
        })
        .catch((err) => {
          this.errors.form.common = 'Ошибка на сервере, обновите страницу и попробуйте ещё раз.';
          // ?
          // this.$bs5utils.Snack.show('danger', err, this.$store.getters.delay.error);
          console.error(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    onMaskaPhone(event) {
      this.objClient.raw.phone = event.detail.unmasked;
    },
  },
  watch: {
    'objClient.country.phone'(newVal) {
      this.objClient.mask.phone = this.countries.filter((el) => el.value == newVal)[0].mask;
      this.form.phone = this.objClient.raw.phone;
    },
    'form.email'(newVal) {
      this.errors.form.email = checkEmail(newVal);
    },
    'form.agree'(newVal) {
      if (newVal) {
        this.errors.form.agree = '';
      } else {
        this.errors.form.agree = 'Подтвердите согласие на обработку персональных данных.';
      }
    },
    'objClient.raw.phone'(newVal) {
      this.errors.form.phone = checkPhone(newVal, this.objClient.phone.completed);
      this.errors.form.common = '';
    },
  },
  mounted() {
    this.objClient.country.phone = this.default.country;
    this.objClient.mask.phone = this.default.mask;
  },
};
</script>

<style lang="scss"></style>
